import { createReducer, createSetter } from "@/redux/helpers/reducer";

import { DISPLAY_MODE_FULL_BREAKDOWN } from "../CreateDocumentModal/constants";

import * as actions from "./create-invoice.actions";

// `invoiceDate` is seeded to today at module-load time. The user can override via
// `setInvoiceDate` after mount; the slice persists across modal open/close cycles
// in the same session.
//
// `lastGeneratedDisplayMode` is null on first generate. When the order has a prior
// generate timeline event, an upstream effect dispatches `setLastGeneratedDisplayMode`
// with the mode used last time. The regenerate banner in the editor uses this to
// nudge the user about resharing.
const initialState = {
  isOpen: false,
  invoiceDate: null,
  activeTab: "actual",
  displayMode: DISPLAY_MODE_FULL_BREAKDOWN,
  lastGeneratedDisplayMode: null,
  oneLinerDescription: "",
  groupedLabourLabel: "",
  groupedMaterialsLabel: "",
  invoiceDisplayModeStatus: null,
};

export default createReducer(initialState, {
  [actions.setIsOpen]: createSetter("isOpen"),
  [actions.setInvoiceDate]: createSetter("invoiceDate"),
  [actions.setActiveTab]: createSetter("activeTab"),
  [actions.setDisplayMode]: createSetter("displayMode"),
  [actions.setLastGeneratedDisplayMode]: createSetter("lastGeneratedDisplayMode"),
  [actions.setOneLinerDescription]: createSetter("oneLinerDescription"),
  [actions.setGroupedLabourLabel]: createSetter("groupedLabourLabel"),
  [actions.setGroupedMaterialsLabel]: createSetter("groupedMaterialsLabel"),
  [actions.setInvoiceDisplayModeStatus]: createSetter("invoiceDisplayModeStatus"),
  [actions.reset]: () => ({ ...initialState, invoiceDate: null }),
});
